angular.module('rjmNg.common.api').factory 'Integrations', [
  "$resource"
  "serviceUrl"
  (
    $resource,
    serviceUrl,
  ) ->

    (clientId) ->

      defaultParams =
        withCredentials: true
        headers:
          Accept: 'application/json'
          'Content-Type': 'application/json'

      actions =
        httpAuthorize: angular.extend {}, defaultParams,
          url: serviceUrl("/clients/#{clientId}/integrations/connections/:id/:type/http/authorize")
          method: 'PUT'
          id: '@id'
          type: '@type'
        oauth1Authorize: angular.extend {}, defaultParams,
          url: serviceUrl("/clients/#{clientId}/integrations/connections/:id/:type/oauth1/authorize")
          method: 'PUT'
          id: '@id'
          type: '@type'
        oauth2Authorize: angular.extend {}, defaultParams,
          url: serviceUrl("/clients/#{clientId}/integrations/connections/:id/:type/oauth2/authorize")
          method: 'PUT'
          id: '@id'
          type: '@type'
        customAuthorize: angular.extend {}, defaultParams,
          url: serviceUrl("/clients/#{clientId}/integrations/connections/:id/:type/authorize")
          method: 'PUT'
          id: '@id'
          type: '@type'

      integrations = $resource(serviceUrl("/clients/#{clientId}/integrations/"), {}, actions)

      httpAuthorize: (integration) ->
        integrations.httpAuthorize({id: integration.id, type: integration.type}, integration.credentials).$promise

      oauth1Authorize: (integration) ->
        integrations.oauth1Authorize({id: integration.id, type: integration.type}, integration.credentials).$promise

      oauth2Authorize: (integration) ->
        integrations.oauth2Authorize({id: integration.id, type: integration.type}, integration.credentials).$promise

      customAuthorize: (integration) ->
        integrations.customAuthorize({id: integration.id, type: integration.type}, integration.credentials).$promise

]
